module.exports = __webpack_public_path__ + "static/media/broadband.03079805.svg";